<div class="modal fade" tabindex="-1" #modalElement>
  <div class="modal-dialog">
    <div class="modal-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
